export const STEPS_NAME = {
  m2mPush: {
    confirmTransfer: "transfer-confirm",
    getTransferStatus: "transfer-status",
    transferForbidden: "transfer-forbidden",
  },
  c2cPush: {
    getLastTransfers: "getLastTransfers",
    getContacts: "getContacts",
    createTransfer: "createTransfer",
    confirmTransfer: "confirmTransfer",
    transferStatus: "transferStatus",
    transferError: "transferError",
    bankSelectionPhone: "bankSelectionPhone",
    bankSelectionContacts: "bankSelectionContacts",
    bankSelectionTransferC2C: "bankSelectionTransferC2C",
  },
  m2mPull: {
    refill: "refill",
    linkingBankSelection: "linkingBankSelection",
    refillLinkedAccount: "refill-linked-account",
    paymentToolsM2M: "paymentToolsM2M",
    refillRequestDetails: "refillRequestDetails",
  },
  sbpSettings: {
    sbpSettings: "sbpSettings",
    autoBankSelection: "autoBankSelection",
    setDefaultBank: "setDefaultBank",
    setDefaultBankSuccess: "setDefaultBankSuccess",
    setDefaultBankFail: "setDefaultBankFail",
    deleteDefaultBank: "deleteDefaultBank",
    deleteDefaultBankSuccess: "deleteDefaultBankSuccess",
    deleteDefaultBankFail: "deleteDefaultBankFail",
  },
  linking: {
    linkingBankSelection: "linkingBankSelection",
    successLinking: "successLinking",
  },
  c2bPush: {
    qrScan: "qrScan",
    qrPayment: "qrPayment",
    qrPaymentSuccess: "qrPaymentSuccess",
    qrPaymentError: "qrPaymentError",
  },
}

export const m2mPushSteps = {
  сonfirmTransfer: {
    name: STEPS_NAME.m2mPush.confirmTransfer,
    title: "",
    previousStep: "",
    nextStep: STEPS_NAME.m2mPush.getTransferStatus,
    hideNavBar: false,
  },
  getTransferStatus: {
    name: STEPS_NAME.m2mPush.getTransferStatus,
    title: "",
    previousStep: "",
    nextStep: "",
    hideNavBar: false,
  },
  transferForbidden: {
    name: STEPS_NAME.m2mPush.transferForbidden,
    title: "",
    previousStep: "",
    nextStep: "",
    hideNavBar: false,
  },
}

export const m2mPullSteps = {
  refill: {
    name: STEPS_NAME.m2mPull.refill,
    title: "Пополнить",
    previousStep: "",
    nextStep: STEPS_NAME.m2mPull.refillRequestDetails,
    hideNavBar: false,
  },
  linkingBankSelection: {
    name: STEPS_NAME.m2mPull.linkingBankSelection,
    title: "Банк списания",
    previousStep: STEPS_NAME.m2mPull.refill,
    nextStep: STEPS_NAME.m2mPull.refill,
    hideNavBar: false,
  },
  paymentToolsM2M: {
    name: STEPS_NAME.m2mPull.paymentToolsM2M,
    title: "Способ пополнения",
    previousStep: STEPS_NAME.m2mPull.refill,
    nextStep: STEPS_NAME.m2mPull.refill,
    hideNavBar: false,
  },
  refillRequestDetails: {
    name: STEPS_NAME.m2mPull.refillRequestDetails,
    title: "",
    previousStep: STEPS_NAME.m2mPull.refill,
    nextStep: "",
    hideNavBar: true,
  },
}

export const c2cPushSteps = {
  getLastTransfers: {
    name: STEPS_NAME.c2cPush.getLastTransfers,
    title: "Кому",
    previousStep: "",
    nextStep: STEPS_NAME.c2cPush.createTransfer,
    hideNavBar: false,
  },
  getContacts: {
    name: STEPS_NAME.c2cPush.getContacts,
    title: "Контакты",
    previousStep: STEPS_NAME.c2cPush.getLastTransfers,
    nextStep: STEPS_NAME.c2cPush.createTransfer,
    hideNavBar: false,
  },
  createTransfer: {
    name: STEPS_NAME.c2cPush.createTransfer,
    title: "Перевести",
    previousStep: STEPS_NAME.c2cPush.getLastTransfers,
    nextStep: STEPS_NAME.c2cPush.confirmTransfer,
    hideNavBar: false,
  },
  confirmTransfer: {
    name: STEPS_NAME.c2cPush.confirmTransfer,
    title: "Подтверждение",
    previousStep: STEPS_NAME.c2cPush.createTransfer,
    nextStep: STEPS_NAME.c2cPush.transferStatus,
    hideNavBar: false,
  },
  transferStatus: {
    name: STEPS_NAME.c2cPush.transferStatus,
    previousStep: STEPS_NAME.c2cPush.confirmTransfer,
    nextStep: "homePage",
    hideNavBar: true,
  },
  transferError: {
    name: STEPS_NAME.c2cPush.transferError,
    previousStep: STEPS_NAME.c2cPush.createTransfer,
    nextStep: "homePage",
    hideNavBar: true,
  },
  bankSelectionPhone: {
    name: STEPS_NAME.c2cPush.bankSelectionPhone,
    title: "Банк получателя",
    previousStep: STEPS_NAME.c2cPush.getLastTransfers,
    nextStep: STEPS_NAME.c2cPush.createTransfer,
    hideNavBar: false,
  },
  bankSelectionContacts: {
    name: STEPS_NAME.c2cPush.bankSelectionContacts,
    title: "Банк получателя",
    previousStep: STEPS_NAME.c2cPush.getContacts,
    nextStep: STEPS_NAME.c2cPush.createTransfer,
    hideNavBar: false,
  },
  bankSelectionTransferC2C: {
    name: STEPS_NAME.c2cPush.bankSelectionTransferC2C,
    title: "Банк получателя",
    previousStep: STEPS_NAME.c2cPush.createTransfer,
    nextStep: STEPS_NAME.c2cPush.createTransfer,
    hideNavBar: false,
  },
}


export const settingsSBPSteps = {
  sbpSettings: {
    name: STEPS_NAME.sbpSettings.sbpSettings,
    title: "Система быстрых платежей",
    previousStep: "",
    nextStep: "",
    hideNavBar: false,
  },
  autoBankSelection: {
    name: STEPS_NAME.sbpSettings.autoBankSelection,
    title: "Запрос перевода со своих счетов",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.sbpSettings,
    hideNavBar: false,
  },
  setDefaultBank: {
    name: STEPS_NAME.sbpSettings.setDefaultBank,
    title: "",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.setDefaultBank,
    hideNavBar: true,
  },
  setDefaultBankSuccess: {
    name: STEPS_NAME.sbpSettings.setDefaultBankSuccess,
    title: "",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.sbpSettings,
    hideNavBar: true,
  },
  setDefaultBankFail: {
    name: STEPS_NAME.sbpSettings.setDefaultBankFail,
    title: "",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.sbpSettings,
    hideNavBar: true,
  },
  deleteDefaultBank: {
    name: STEPS_NAME.sbpSettings.deleteDefaultBank,
    title: "",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.deleteDefaultBank,
    hideNavBar: true,
  },
  deleteDefaultBankSuccess: {
    name: STEPS_NAME.sbpSettings.deleteDefaultBankSuccess,
    title: "",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.sbpSettings,
    hideNavBar: true,
  },
  deleteDefaultBankFail: {
    name: STEPS_NAME.sbpSettings.deleteDefaultBankFail,
    title: "",
    previousStep: STEPS_NAME.sbpSettings.sbpSettings,
    nextStep: STEPS_NAME.sbpSettings.sbpSettings,
    hideNavBar: true,
  },
}

export const accountLinkingSteps = {
  linkingBankSelection: {
    name: STEPS_NAME.linking.linkingBankSelection,
    title: "Выбор банка",
    previousStep: "",
    nextStep: STEPS_NAME.linking.successLinking,
    hideNavBar: false,
  },
  successLinking: {
    name: STEPS_NAME.linking.successLinking,
    title: "",
    previousStep: STEPS_NAME.linking.linkingBankSelection,
    nextStep: "homePage",
    hideNavBar: true,
  },
}

export const c2bPushSteps = {
  qrScan: {
    name: STEPS_NAME.c2bPush.qrScan,
    title: "",
    previousStep: "",
    nextStep: STEPS_NAME.c2bPush.qrPayment,
    hideNavBar: true,
  },
  qrPayment: {
    name: STEPS_NAME.c2bPush.qrPayment,
    title: "Оплата через СБП",
    previousStep: STEPS_NAME.c2bPush.qrScan,
    nextStep: STEPS_NAME.c2bPush.qrPaymentSuccess,
    hideNavBar: false,
  },
  qrPaymentSuccess: {
    name: STEPS_NAME.c2bPush.qrPaymentSuccess,
    title: "",
    previousStep: STEPS_NAME.c2bPush.qrPayment,
    nextStep: "homePage",
    hideNavBar: false,
  },
  qrPaymentError: {
    name: STEPS_NAME.c2bPush.qrPaymentError,
    title: "",
    previousStep: STEPS_NAME.c2bPush.qrScan,
    nextStep: "homePage",
    hideNavBar: true,
  },
}
